import React from 'react';
import NavBar from './NavBar';
import SideBar from './SideBar';
import Processando from './Processando';

import 'semantic-ui-css/semantic.min.css';
import '../css/bootstrap.css';
import '../css/app.css';
import '../css/custom.css';

export default function ErpTemplate({ children, sidebar = true, processando = false, idioma = 'portugues' }) {
    // Detecta se está no ambiente de teste
    const isTestEnvironment = process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.includes('apiteste');

    return (
        <>
            <NavBar />
            {sidebar === true ? <SideBar /> : null}
            <div id="main" style={{ marginLeft: sidebar === true ? "75px" : "0px" }}>
                {children}
                <div style={{ height: "100px" }}></div>
                {processando && <Processando idioma={idioma} />}
            </div>

            {/* Indicador flutuante do ambiente de teste */}
            {isTestEnvironment && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#ff6b35',
                    color: 'white',
                    padding: '8px 15px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    zIndex: 9999,
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                    border: '2px solid #fff',
                    animation: 'pulse 2s infinite',
                    cursor: 'default',
                    userSelect: 'none'
                }}>
                    🧪 TESTE
                </div>
            )}

            {/* CSS para animação do indicador */}
            {isTestEnvironment && (
                <style>{`
                    @keyframes pulse {
                        0% { transform: scale(1); }
                        50% { transform: scale(1.05); }
                        100% { transform: scale(1); }
                    }
                `}</style>
            )}
        </>
    );
}

